import { doPost } from "./common";
import env from "utils/env";
import { getItem } from 'utils/local-storage';
import { ACCESS_TOKEN } from 'utils/storage-keys';

interface Response {
  id: string;
  created_at: number;
  created_at_utc: string;
  updated_at: number;
  updated_at_utc: string;
  author: string;
  description: string;
}

interface Params {}

async function redeemVoucherAPI(code: string) {
  const config = env();
  const BASE_URL = config.baseApiUrl;
  const USER_REDEEM_URL = `${BASE_URL}/voucher/{$CODE$}`;
  const url = USER_REDEEM_URL.replace('{$CODE$}', code);
  
  return doPost<Response, Params>(
    url,
    {},
    { 'X-Session-Token': getItem(ACCESS_TOKEN) }
  );
}

export default redeemVoucherAPI;
